'use strict';

angular.module('docketbook').
  controller('selectLineController', function($rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout) {

    // Initialise variables to be used
    $scope.lineSearch = "";
    $scope.lineItemList = [];
    $scope.lineItemListFull = [];
    $scope.lineSelectCallback = null;
    $scope.desktopSelected = [];

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.lineSelectFromParent = function(list, cb) {
      $scope.lineSearch = "";
      $scope.lineItemListFull = list;
      $scope.lineItemList = list;
      $scope.lineSelectCallback = cb;
      $scope.desktopSelected = [];

      if ( $stateParams.device == 'desktop' ) {
        $("#selectLineModal").fadeIn(100);
      }
    }

    $scope.selectLineItem = function(lineItem) {
      $scope.lineSelectCallback(lineItem);
    }

    $scope.closeLineSelectList = function() {
      if ( $stateParams.device == 'desktop' ) {
        $("#selectLineModal").fadeOut(100);
      }
      $scope.lineSelectCallback(null);
    }

    $scope.desktopSelectLinesContinue = function() {
      $scope.lineSelectCallback($scope.desktopSelected);
      $("#selectLineModal").fadeOut(100);
    }

    /********************************/
    /***** Search Functionality *****/
    /********************************/

    $scope.updateLineSearch = function(searchValue) {
      if ( searchValue === "" ) {
        $scope.lineItemList = $scope.lineItemListFull;
        return;
      }

      // update lineItemList with filtered results
      var filteredList = [];
      for ( var i = 0; i < $scope.lineItemListFull.length; i++ ) {
        if ( $scope.lineItemListFull[i].resource.name.indexOf(searchValue) != -1 ) {
          filteredList.push($scope.lineItemListFull[i]);
        }
      }

      $scope.lineItemList = filteredList;
    }

});



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectLineController.js